import React, { FC } from 'react';

import { faEye } from '@fortawesome/free-solid-svg-icons';

import { AbstractIcon } from '../abstract-icon';

interface Props {
  className?: string;
}

const ShowIcon: FC<Props> = props => <AbstractIcon {...props} icon={faEye} />;

export { ShowIcon };